import navigation from "@/navigation";
import info from "@/info";

export default {
    adminRole(role) {
        return info.user?.adminRoles?.includes(role) === true;
    },
    permission(permission) {
        return this.communityAdministrator() || info.community?.user?.permissions?.includes(permission) === true;
    },
    route(route) {
        return navigation.isRouteAuthorized(route);
    },
    resourcePermission(type, id, permission) {
        return info.community?.user?.resourcePermissions?.includes(type + ":" + id + ":" + permission) === true;
    },
    resourceTypePermission(type, permission) {
        return info.community?.user?.resourcePermissions?.some(item => item.startsWith(type + ":") && item.endsWith(":" + permission));
    },
    moduleEnabled(module) {
        return info.community?.enabledModules?.includes(module) === true;
    },
    communityAdministrator() {
        return info.community?.user?.administrator === true;
    }
};